import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../providers/user';

const ProtectedRoute = () => {
  const { user } = useUser();
  const isAuthenticated = !!user;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
